import type { Tab } from 'rc-tabs/lib/interface';
import { heapTabs } from '../constants';
import type { HeapApiOptionType } from '../types';
import { HeapList, HeapManagementGuide, VolumeCalculation } from '.';

export const HeapClusterManagementTabs = ({
  heapListResponse,
  isHeapListLoading,
  heapListRefetch,
  selectedClusters,
  onSelectClusterHandler,
  setActiveTabKey,
  setIsHeapsTableVisible,
  isHeapsTableVisible,
  setActiveHeapCluster,
  activeHeapCluster,
  setIsHeapClusterModified,
  importWKTPolygon,
  scrollToClusterId,
  setScrollToClusterId,
}: HeapApiOptionType): Tab[] => {
  return [
    {
      label: heapTabs.Draw,
      children: (
        <VolumeCalculation
          heapListRefetch={heapListRefetch}
          onSelectClusterHandler={onSelectClusterHandler}
          setActiveTabKey={setActiveTabKey}
        />
      ),
      key: heapTabs.Draw,
    },
    {
      label: heapTabs.List,
      children: (
        <HeapList
          heapListResponse={heapListResponse}
          isHeapListLoading={isHeapListLoading}
          heapListRefetch={heapListRefetch}
          selectedClusters={selectedClusters}
          onSelectClusterHandler={onSelectClusterHandler}
          setActiveTabKey={setActiveTabKey}
          setIsHeapsTableVisible={setIsHeapsTableVisible}
          isHeapsTableVisible={isHeapsTableVisible}
          setActiveHeapCluster={setActiveHeapCluster}
          activeHeapCluster={activeHeapCluster}
          setIsHeapClusterModified={setIsHeapClusterModified}
          importWKTPolygon={importWKTPolygon}
          scrollToClusterId={scrollToClusterId}
          setScrollToClusterId={setScrollToClusterId}
        />
      ),
      key: heapTabs.List,
    },
    {
      label: heapTabs.Guide,
      children: <HeapManagementGuide />,
      key: heapTabs.Guide,
    },
  ];
};
